import { cn } from '@cleanlab/design-system/utils'

import landingImage from '@/assets/images/landing/landing-image.webp'
import landingImageBg from '@/assets/images/landing/landing-image-bg.webp'

export function LandingGraphic({ className = '' }: { className?: string }) {
  return (
    <div
      style={{
        backgroundImage: `url(${landingImageBg.src})`,
      }}
      className={cn(
        'relative flex items-center justify-center overflow-hidden bg-surface-1 bg-cover bg-center bg-no-repeat px-11 py-[80px]',
        className
      )}
    >
      {/* Use image as background to make it fit container */}
      <div
        style={{
          backgroundImage: `url(${landingImage.src})`,
        }}
        className="relative size-full max-w-[608px] bg-contain bg-center bg-no-repeat"
      >
        {/* Provide non-visible image with alt te for accessibility */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className="sr-only"
          src={landingImage.src}
          alt="A comparison image showing two virtual agent responses to the same customer question. In the first example, the virtual agent responds with “Sorry, I couldn’t find any information about that,” which is marked as unsatisfactory with a red border. In the second example, the virtual agent responds with a helpful message explaining that Apple Pay is not supported but lists alternative payment options like PayPal, Google Pay, and Zelle, marked as satisfactory with a green border. The caption at the bottom mentions “Reliability Improved with Cleanlab Codex.”"
        />
      </div>
    </div>
  )
}
